import { render, staticRenderFns } from "./ManagingRolesAndPermissions.vue?vue&type=template&id=52e6c174"
import script from "./ManagingRolesAndPermissions.vue?vue&type=script&lang=js"
export * from "./ManagingRolesAndPermissions.vue?vue&type=script&lang=js"
import style0 from "./ManagingRolesAndPermissions.vue?vue&type=style&index=0&id=52e6c174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports